import { Button, Col, Form, Input, Row, Typography, Image, theme, notification, AutoComplete } from "antd";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { getDepartments, publicRegister } from "../../services/publicApi";
import {
    EmailDescription,
    FirstNameDescription,
    LastNameDescription,
    MobileDescription,
    PasswordDescription,
    PasswordRegexExpression,
    PasswordRequirementText,
} from "../../shared/constants/Resources";
import { MowiLogo } from "../../shared/constants/Images";
import ContainerLayout from "../common/containerLayout";
import "./styles.css";

const { Title } = Typography;

export const Register = () => {
    const { token } = theme.useToken();
    const [searchParams] = useSearchParams();
    const [isLoading, setIsLoading] = useState(false);
    const [form] = Form.useForm();
    const [departments, setDepartments] = useState<{ value: string; label: string }[]>([]);

    const registrationCode = searchParams.get("code") || "";
    const emailParam = searchParams.get("email") || "";

    useEffect(() => {
        const fetchDepartments = async () => {
            try {
                const response = await getDepartments(registrationCode);
                if (response.success && response.data) {
                    const departmentOptions = response.data.map((dept: any) => ({
                        value: dept.name,
                        label: dept.name,
                    }));
                    setDepartments(departmentOptions);
                }
            } catch (error) {
                console.error("Error fetching departments:", error);
            }
        };
    
        if (!registrationCode) {
            notification.error({
                message: "Código de registro faltante.",
                placement: "bottom",
                key: "global"
            });
        } else {
            fetchDepartments();
        }
    }, [registrationCode]);

    const onFinish = async (values: any) => {
        setIsLoading(true);
        const payload = {
            firstName: values.firstName,
            lastName: values.lastName,
            email: values.email,
            mobile: values.mobile,
            password: values.password,
            department: values.department,
            registrationCode: registrationCode,
        };

        try {
            const response = await publicRegister(payload);
            if (response.success) {
                notification.success({
                    message: "Cuenta creada exitosamente.",
                    placement: "bottom",
                    key: "global"
                });
            }
        } catch (error: any) {
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <ContainerLayout showNotification={false} defaultContainer={false}>
            <Row justify="center" align="middle" style={{ minHeight: "100dvh", width: "100%" }}>
                <Col xs={22} sm={16} md={12} lg={8} xl={6}>
                    <div className="register-card" style={{ background: token.colorBgContainer }}>
                        <Row justify="center" style={{ marginBottom: 24 }}>
                            <Image src={MowiLogo} height={50} preview={false} />
                        </Row>
                        <Title level={2} style={{ textAlign: "center", marginBottom: 24 }}>
                            Crear Cuenta
                        </Title>
                        <Form
                            layout="vertical"
                            form={form}
                            name="register"
                            onFinish={onFinish}
                            scrollToFirstError
                            initialValues={{
                                registrationCode: registrationCode,
                                [EmailDescription]: emailParam
                            }}
                        >
                            <Form.Item
                                name={FirstNameDescription}
                                label="Primer Nombre"
                                rules={[
                                    {
                                        required: true,
                                        message: "Por favor inserte su nombre",
                                        whitespace: true,
                                    },
                                ]}
                            >
                                <Input placeholder="Nombre" />
                            </Form.Item>
                            <Form.Item
                                name={LastNameDescription}
                                label="Primer Apellido"
                                rules={[
                                    {
                                        required: true,
                                        message: "Por favor inserte su apellido",
                                        whitespace: true,
                                    },
                                ]}
                            >
                                <Input placeholder="Apellido" />
                            </Form.Item>
                            <Form.Item
                                name={EmailDescription}
                                label="Correo electrónico"
                                rules={[
                                    {
                                        required: true,
                                        type: "email",
                                        message: "Por favor inserte un correo válido",
                                    },
                                ]}
                            >
                                <Input placeholder="correo@ejemplo.com" disabled={!!emailParam} />
                            </Form.Item>
                            <Form.Item
                                name="department"
                                label="Departamento"
                                rules={[
                                    {
                                        required: true,
                                        message: "Por favor seleccione o ingrese un departamento",
                                    },
                                    {
                                        max: 255,
                                        message: "El nombre del departamento no puede exceder 255 caracteres",
                                    },
                                ]}
                            >
                                <AutoComplete
                                    options={departments}
                                    placeholder="Seleccione o escriba un departamento"
                                    filterOption={(inputValue, option) =>
                                        option!.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                    }
                                />
                            </Form.Item>
                            <Form.Item
                                name={MobileDescription}
                                label="Teléfono"
                                rules={[
                                    {
                                        required: true,
                                        message: "Por favor inserte un número telefónico",
                                    },
                                ]}
                            >
                                <Input placeholder="58000000000" />
                            </Form.Item>
                            <Form.Item
                                name={PasswordDescription}
                                label="Contraseña"
                                rules={[
                                    {
                                        required: true,
                                        message: "Por favor inserte una contraseña",
                                    },
                                    {
                                        pattern: PasswordRegexExpression,
                                        message: PasswordRequirementText,
                                    },
                                ]}
                            >
                                <Input.Password placeholder="*******" />
                            </Form.Item>

                            <Form.Item>
                                <Button type="primary" htmlType="submit" loading={isLoading} block size="large">
                                    Registrarse
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                </Col>
            </Row>
        </ContainerLayout>
    );
};

export default Register;
